import { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import { colors, styleScreenDashboard } from "../../styles/style";
import ColorStatus from "../circleColorStatus/ColorStatus";
import { AiOutlineFileDone } from "react-icons/ai";
import { FiAlertOctagon, FiAlertTriangle, FiCheckCircle } from "react-icons/fi";

import useListDashboardData from "../../hooks/useListDashboardData";
import LevelIndicator from "../levelDelivery/levelIndicator";
import useToCommisions from "../../services/charges/useToCommisions";
import CheckType from "../../utilities/dateFormat/checkType";
import { getCurrentOrderByIdDealer } from "../../graphql/myQueries";
import { API, graphqlOperation } from "aws-amplify";
import ModalCurrentOrder from "../modals/modalCurrentOrder";
import NewTimer2 from "../../components/sendedOrders/toReassign";
const initialMethodPay = {
  card: 0,
  cash: 0,
};
const CardDelivery = ({ item, selectDelivery }) => {
  const [ordersByDay, setOrdersByDay] = useState([]);
  const { getOrderByDate, getCurrentOrder } = useListDashboardData();
  const { calculateDebts } = useToCommisions();
  const [byMethodPay, setByMethodPay] = useState(initialMethodPay);
  //? data to use the modal of the current order
  const [currentOrderDealer, setCurrentOrderDealer] = useState({});
  //console.log("🚀 ~ file: cardDelivery.js:27 ~ CardDelivery ~ currentOrderDealer", currentOrderDealer)
  const [show, setShow] = useState(false);
  const [assigned, setAssigned] = useState(null);
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    initialCardOrders();
    showOrderInService();
    /* return () => {
      second
    } */
  }, [item]);

  async function initialCardOrders() {
    var currentDateToString = CheckType("current");
    //console.log("Fecha actual ", currentDateToString);
    var results = await getOrderByDate(item.id, currentDateToString);
    var current_ = await getCurrentOrder(item.id);
    if (current_.length !== 0) {
      setCurrent(current_);
      let bd_history = JSON.parse(current_.history);
      let last_element = bd_history[bd_history.length - 1];
      //setAssigned(last_element.hour);
      if (
        last_element.change &&
        last_element.change === "ASSIGMENT IN SERVICE DESKTOP"
      )
        setAssigned(last_element.hour);
    }

    let _cash = 0;
    let _card = 0;
    results.forEach((element) => {
      var fees =
        element.shipping_fees !== undefined && element.shipping_fees !== null
          ? JSON.parse(element.shipping_fees)
          : {};
      var costForDistance = fees.collection
        ? fees.delivery + fees.distance + fees.collection
        : 0;

      element.method_pay === "EFECTIVO"
        ? (_cash += parseFloat(calculateDebts(costForDistance)))
        : (_card += parseFloat(calculateDebts(costForDistance)));
    });
    setByMethodPay({ card: _card, cash: _cash });
    setOrdersByDay(results);
  }

  const detailsToMethodPay = () => {
    let type =
      byMethodPay.cash === 0
        ? "normal"
        : byMethodPay.cash !== 0 && byMethodPay.cash < 500
        ? "warning"
        : "error";

    if (type === "normal") {
      return <FiCheckCircle size={20} color={colors.GREEN_COLOR} />;
    } else if (type === "warning") {
      return <FiAlertTriangle size={20} color={colors.YELLOW_COLOR} />;
    } else {
      return <FiAlertOctagon size={20} color={colors.RED_ALERT} />;
    }
  };

  //? states to control the modal
  const handleClose = () => {
    setShow(false);
    setCurrentOrderDealer({});
  };
  const handleShow = () => setShow(true);

  /**Function to get the current order in transit from id delivery
   * @param {String} idDelivery id of the delivery
   */
  const showOrderInService = () => {
    API.graphql(graphqlOperation(getCurrentOrderByIdDealer, { id: item.id }))
      .then((res) => {
        let dataOrder = res?.data?.getAccount?.deliveryman_orders?.items[0];
        if (!!dataOrder) {
          setCurrentOrderDealer(dataOrder);
          //handleShow();
        }
      })
      .catch((err) => {
        console.log("Error [showOrderInService] ", err);
      });
  };

  /**
   * Function to select the delivery to assign in order (v1 multiorder)
   * @param {String} idDelivery id of the delivery
   */
  const handleSelectDelivery = (idDelivery) => {
    let dataCurrentOrder =
      currentOrderDealer !== {} ? currentOrderDealer : false;
    selectDelivery(idDelivery, dataCurrentOrder);
  };

  return (
    <>
      {currentOrderDealer !== {} && show && (
        <ModalCurrentOrder
          order={currentOrderDealer}
          show={show}
          handleClose={handleClose}
        />
      )}
      <button
        disabled={!!currentOrderDealer.id ? true : !!item.selected ? true : false}
        style={styleScreenDashboard.cardColumnDelivery}
        type="button"
        onClick={() => handleSelectDelivery(item.id)}
      >
        <Card style={styleScreenDashboard.borderCards}>
          <Card.Body>
            <Card.Title style={styleScreenDashboard.textCardDelivery}>
              <div className="row">
                <div className="row col-10">
                  <div className="col-2">
                    <LevelIndicator info={item} />
                  </div>
                  <div className="col-10">
                    <p>{item.name + " " + item.last_name}</p>
                  </div>
                </div>
                <div
                  className="col"
                  style={{
                    justifyContent: "center",
                    flexDirection: "row",
                    display: "flex",
                    alignItems: "center",
                    alignSelf: "center",
                  }}
                >
                  <AiOutlineFileDone size={20} color={colors.BLUE_COLOR} />
                  <Card.Text>{ordersByDay.length}</Card.Text>
                </div>
              </div>
            </Card.Title>
            <Card.Text style={styleScreenDashboard.textCardDelivery}>
              {item?.delivery_transport}
            </Card.Text>
            {item?.delivery_inprocess && currentOrderDealer !== {} && (
              <button
                style={styleScreenDashboard.btnContainer}
                type="button"
                onClick={() => handleShow()}
              >
                <Card style={styleScreenDashboard.simpleInsideCard}>
                  <Card.Text style={styleScreenDashboard.textCenteredCard}>
                    {assigned !== null ? (
                      <NewTimer2
                        order={current}
                        orderID={item.id}
                        start={assigned}
                        //order={item}
                      />
                    ) : (
                      "Repartidor en servicio"
                    )}
                  </Card.Text>
                </Card>
              </button>
            )}
            <div className="row">
              <div className="col-6">
                {!!item.statusDelivery && item.statusDelivery !== "none" && (
                  <ColorStatus
                    statusDelivery={item.statusDelivery}
                    kmDistance={item.kmDistance}
                  />
                )}
              </div>
              <div className="col">
                <div className="row">
                  <div className="col">{detailsToMethodPay()}</div>
                  <div className="col">${byMethodPay.cash.toFixed(2)}</div>
                </div>
              </div>
            </div>
          </Card.Body>
        </Card>
      </button>
    </>
  );
};
export default CardDelivery;
